import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
      marginBottom: 10,
    },
    content: {
      background: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : '#f9fcff',
      border: '1px solid',
      borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
      borderRadius: 5,
      padding: '15px 20px',
    },
  }),
);
